import Enums from "../../enums/enums";
import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import helper from "./transactionHelper";
export default {
  DoGetTagList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI.post("/api/Transaction/GetTagList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateNewTag(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      tagName: input.tagName,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/CreateNewTag", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertTagTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
      tagIdList: input.tagIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/InsertTagTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnattachTagTransaction(tagTransactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      tagTransactionId: tagTransactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/UnattachTagTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTagDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
    };
    return API.peakRealTimeAPI.post("/api/Tag/GetTagDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: input.financeTypeId,
      transactionTypeId: input.transactionTypeId,
      transactionId: input.transactionId,
    };
    return API.peakRealTimeAPI.post("/api/File/GetFile", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCommentList(input, isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Comment/GetCommentList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoInsertComment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
      commentText: input.commentText,
    };
    return API.peakRealTimeAPI.post("/api/Comment/InsertComment", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteComment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      commentId: input.commentId,
    };
    return API.peakRealTimeAPI.post("/api/Comment/DeleteComment", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoGetSuggestionTransactionNumber(transaction) {
    let isCreateTaxInvoice = transaction.issueTaxInvoice != null ? transaction.issueTaxInvoice.value : false;
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: transaction.transactionType,
      financeType: transaction.financeType,
      expenseType: helper.GetExpenseTypeForGetSuggestionTransactionNumber(transaction),
      date: transaction.date.value,
      isCreateTaxInvoice: isCreateTaxInvoice,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/GetSuggestionTransactionNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateQuotation(status, transaction) {
    let transactionInput = helper.GetCreateQuotationInput(status, transaction);
    let _input = {
      financeType: transactionInput.financeType,
      transactionItemType: transactionInput.transactionItemType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
    };

    return API.peakRealTimeAPI
      .post("/api/Quotation/CreateQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoice(status, transaction) {
    let transactionInput = helper.GetCreateInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      expenseType: transactionInput.expenseType,
      transactionItemType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Invoice/CreateInvoice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateCreditNote(status, transaction) {
    let transactionInput = helper.GetCreateCreditNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      transactionItemType: transactionInput.transactionItemType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/CreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateDebitNote(status, transaction) {
    let transactionInput = helper.GetCreateDebitNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      expenseType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/CreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateInvoiceWithUploadDocument(uploadDocumentList, status, transaction) {
    let transactionInput = helper.GetCreateInvoiceInput(status, transaction);
    let _input = {
      financeType: transactionInput.financeType,
      expenseType: transactionInput.expenseType,
      transaction: transactionInput.transaction,
      uploadDocumentList: uploadDocumentList,
    };
    return API.peakRealTimeAPI
      .post(
        "/api/UploadDocument/CreateInvoiceWithUploadDocument",
        _input,
        userInfo.SetHeaderService(Enums.SourceTypeProject.FileVault)
      )
      .then((res) => {
        return res;
      });
  },
  DoCreateReceipt(status, transaction) {
    let transactionInput = helper.GetCreateReceiptInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      transactionItemType: transactionInput.transactionItemType,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/CreateReceiptOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateBillingNote(status, transaction) {
    let transactionInput = helper.GetCreateBillingNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
      isAllowDupplicateReceivedBillingNoteNumber: transaction.isAllowDupplicateReceivedBillingNoteNumber,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/CreateBillingNoteOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateTaxInvoice(status, transaction) {
    let transactionInput = helper.GetCreateTaxInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/CreateTaxInvoiceOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateTaxInvoice(transactionId, transactionTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: transactionTypeId,
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTransactionForCreateTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionListForCreateTaxInvoice(transactionTypeId, contactId, month, year, searchText) {
    let date = helper.GetFromAndToDate(month, year);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: transactionTypeId,
      contactId: contactId,
      fromDate: new Date(date.fromDate).ToDateJsonString(),
      toDate: new Date(date.toDate).ToDateJsonString(),
      searchText: searchText,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTransactionListForCreateTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationById(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      quotationId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetQuotationById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationForCreateTransaction(id) {
    let _input = {
      id: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetQuotationForCreateTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      quotationId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetQuotationDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptById(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receiptId: id,
    };
    return API.peakRealTimeAPI.post("/api/Receipt/GetReceiptById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceiptDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receiptId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetReceiptDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceId: id,
    };
    return API.peakRealTimeAPI.post("/api/Invoice/GetInvoiceById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUnpaidInvoiceList(financeType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeType: financeType,
    };
    return API.peakAPI
      .post("/api/Transaction/GetUnpaidInvoiceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTaxInvoiceById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTaxInvoiceDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateCreditNote(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetTransactionForCreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTransactionForCreateDebitNote(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetTransactionForCreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetailForPage(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteDetailForPage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetBillingNoteById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForEditById(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetBillingNoteForEditById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditQuotation(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateQuotationInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Quotation/EditQuotation", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditBillingNote(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateBillingNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      financeType: transactionInput.financeType,
      transaction: transactionInput.transaction,
      status: status,
      isAllowDupplicateReceivedBillingNoteNumber: transaction.isAllowDupplicateReceivedBillingNoteNumber,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/EditBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditInvoice(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Invoice/EditInvoice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditReceipt(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateReceiptInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/Receipt/EditReceipt", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditTaxInvoice(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateTaxInvoiceInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/EditTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditCreditNote(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateCreditNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/EditCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditDebitNote(transactionId, transaction, status) {
    let transactionInput = helper.GetCreateDebitNoteInput(status, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transaction: transactionInput.transaction,
      status: status,
      isValidateCreditLimit: transaction.isValidateCreditLimit,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI.post("/api/DebitNote/EditDebitNote", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBillingNoteForCreateReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetBillingNoteForCreateReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForCreateReceipt(transactionId, paymentGroupId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      paymentGroupId: paymentGroupId,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetInvoiceForCreateReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceBillingNoteDetail(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };

    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceBillingNoteDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetReceiptDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetReceiptDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteSummaryByTransacrionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
      financeTypeId: input.financeTypeId,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetCreditNoteSummaryByTransacrionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteSummaryByTransacrionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionTypeId: input.transactionTypeId,
      financeTypeId: input.financeTypeId,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetDebitNoteSummaryByTransacrionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidPaidPayment(paymentGroupId, transactionId, transactionType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      paymentGroupId: paymentGroupId,
      transactionId: transactionId,
      transactionType: transactionType,
    };
    return API.peakRealTimeAPI.post("/api/Payment/VoidPaidPayment", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoPaidPaymentByTransactionType(transactionId, transactionType, payment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transactionType: transactionType,
      payment: helper.ConvertPaymentForCreate(payment),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/PaidPaymentByTransactionType", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetInvoiceForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetCreditNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetDebitNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForDoPaidPayment(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetBillingNoteForDoPaidPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByQuotationId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetTimelineByQuotationId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByInvoiceId(transactionId, isQueryAllTimeLine) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      isQueryAllTimeLine: isQueryAllTimeLine,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetTimelineByInvoiceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByReceiptId(transactionId, isQueryAllTimeLine) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      isQueryAllTimeLine: isQueryAllTimeLine,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/GetTimelineByReceiptId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByTaxInvoiceId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetTimelineByTaxInvoiceId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByBillingNoteId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/GetTimelineByBillingNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByCreditNoteId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/GetTimelineByCreditNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByDebitNoteId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/GetTimelineByDebitNoteId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  IsInvoiceInBillingNoteHaveTaxInvoiceByBillingNoteId(billingNoteId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      billingNoteId: billingNoteId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/IsInvoiceInBillingNoteHaveTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByPurchaseOrderId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/GetTimelineByPurchaseOrderId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTimelineByExpenseId(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetTimelineByExpenseId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidQuotation(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/VoidQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI.post("/api/Transaction/VoidInvoice", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoVoidReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI.post("/api/Transaction/VoidReceipt", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoVoidTaxInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/VoidTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/VoidCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidBillingNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/VoidBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/VoidDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRejectTransaction(input) {
    let _input = {
      data: {
        merchantId: userInfo.MerchantId(),
        transactionId: input.transactionId,
        transactionType: input.transactionType,
        comment: input.comment,
        financeType: input.financeType,
        rejectType: input.rejectType,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/RejectTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region InsertFileTransaction
  DoInsertQuotationFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/InsertQuotationFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertInvoiceFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeForUploadAPI
      .post("/api/Invoice/InsertInvoiceFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertReceiptFile(input) {
    let formData = new FormData();
    formData.append("merchantId", userInfo.MerchantId());
    formData.append("transactionId", input.transactionId);
    input.fileList.forEach((file, index) => {
      let blob = helper.Base64ToBlob(file.rawString, file.fileType);
      formData.append(`fileList[${index}]`, blob, file.fileName);
    });
    return API.peakRealTimeForUploadAPI
      .post("/api/Receipt/InsertReceiptFile", formData, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertTaxInvoiceFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/InsertTaxInvoiceFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertCreditNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/InsertCreditNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertDebitNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/InsertDebitNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoInsertBillingNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/InsertBillingNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region deleteFile
  DoDeleteQuotationFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/Quotation/DeleteQuotationFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteInvoiceFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/Invoice/DeleteInvoiceFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteReceiptFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/Receipt/DeleteReceiptFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteTaxinvoiceFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/Taxinvoice/DeleteTaxinvoiceFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteCreditNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/CreditNote/DeleteCreditNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteDebitNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/DebitNote/DeleteDebitNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteBillingNoteFile(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      fileList: input.fileList,
    };

    return API.peakRealTimeAPI
      .post("/api/BillingNote/DeleteBillingNoteFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  DoGetInvoiceDetailForEdit(id) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceId: id,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetInvoiceDetailForEdit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReferenceTransactionPaymentByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionTypeId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetReferenceTransactionPaymentByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByBillingNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
    };

    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentAndReferenceJournalDetailByReceipt(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      referenceId: input.referenceId,
      receiptReferenceType: input.receiptReferenceType,
      receiptReferencePaymentGroupId: input.receiptReferencePaymentGroupId,
    };
    return API.peakRealTimeAPI
      .post("/api/Payment/GetPaymentAndReferenceJournalDetailByReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region bookmark
  DoCreateBookmark(state, transaction) {
    let transactionInput = helper.GetCreateBookmarkInput(state.setBookmark, transaction);
    let _input = {
      merchantId: userInfo.MerchantId(),
      transaction: transactionInput,
    };
    return API.peakRealTimeAPI.post("/api/Bookmark/SaveBookmark", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBookmarkList(input) {
    let _input = helper.GetBookmarkListInput(input);
    return API.peakAPI.post("/api/Bookmark/GetBookmarkList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBookmarkTemplateList(bookmarkId) {
    let _input = helper.GetBookmarkTemplateInput(bookmarkId);
    return API.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetailById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBookmarkDetailList(transactionTemplateId) {
    let _input = helper.GetBookmarkDetailListInput(transactionTemplateId);
    return API.peakRealTimeAPI
      .post("/api/Bookmark/GetBookmarkDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteBookmark(bookmarkId) {
    let _input = helper.DeleteBookmarkInput(bookmarkId);
    return API.peakRealTimeAPI
      .post("/api/Bookmark/DeletedBookmark", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAISuggestionAccountByContact(contactId, financeType, transactionItemTypeList) {
    let _input = {
      contactId: contactId,
      financeType: financeType,
      transactionItemTypeList: transactionItemTypeList,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/GetAISuggestionAccountByContact", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region purchase taxinvoice
  DoCreateReceivedTaxInvoice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receivedTaxInvoiceList: [],
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      paymentGroupId: input.referencePaymentGroupId,
      language: i18n.locale,
    };
    if (input.receivedTaxInvoiceList && input.receivedTaxInvoiceList) {
      for (let receivedTaxInvoice of input.receivedTaxInvoiceList) {
        _input.receivedTaxInvoiceList.push({
          receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
          receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
          preVatTotal: receivedTaxInvoice.preVatTotal,
          vatTotal: receivedTaxInvoice.vatTotal,
          netAmount: receivedTaxInvoice.netAmount,
        });
      }
    }
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/DoCreateReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidReceivedTaxInvoice(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receivedTaxInvoice: {
        receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
        preVatTotal: input.receivedTaxInvoice.preVatTotal,
        vatTotal: input.receivedTaxInvoice.vatTotal,
        netAmount: input.receivedTaxInvoice.netAmount,
        referenceTransactionId: input.transactionId,
        referenceTransactionType: input.transactionType,
        referencePaymentGroupId: input.referencePaymentGroupId,
        id: input.receivedTaxInvoice.id,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/VoidReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetReceivedTaxInvoiceByReferenceTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/GetReceivedTaxInvoiceByReferenceTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoRerecordJournalReceivedTaxInvoice(input) {
    let _input = {
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      receivedTaxInvoiceId: input.receivedTaxInvoiceId,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/RerecordJournalReceivedTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion

  //#region recurring
  DoGetSuggestionRecurringNumber(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: input.transactionType,
      financeType: input.financeType,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetSuggestionRecurringNumber", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateRecurringInvoice(invoiceRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceRecurringTemplate: invoiceRecurringTemplate,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/CreateRecurringInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateRecurringReceipt(receiptRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receiptRecurringTemplate: receiptRecurringTemplate,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/CreateRecurringReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecurringInvoiceTemplateDetail(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetRecurringInvoiceTemplateDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRecurringReceiptTemplateDetail(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/GetRecurringReceiptTemplateDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringInvoiceTemplate(invoiceRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: invoiceRecurringTemplate.id,
      invoiceRecurringTemplate: invoiceRecurringTemplate,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/UpdateRecurringInvoiceTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringReceiptTemplate(receiptRecurringTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: receiptRecurringTemplate.id,
      receiptRecurringTemplate: receiptRecurringTemplate,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/UpdateRecurringReceiptTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsArchive(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: input.recurringTemplateId,
      isArchive: input.isArchive,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/UpdateRecurringIsArchive", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsAutoSendEmail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: input.recurringTemplateId,
      isAutoSendEmail: input.isAutoSendEmail,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/UpdateRecurringIsAutoSendEmail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRecurringIsDelete(recurringTemplateId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      recurringTemplateId: recurringTemplateId,
    };
    return API.peakRealTimeAPI
      .post("/api/Recurring/UpdateRecurringIsDelete", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  DoSendEmailTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      financeType: input.financeType,
      transactionType: input.transactionType,
      emailMessage: {
        toEmail: input.toEmail,
        toBccEmail: input.bccEmail,
        toCcEmail: input.ccEmail,
        linkFile: input.linkFile,
        messageFromSender: input.messageFromSender,
        messageSubject: input.subject,
        sendEmail: input.sendEmail.email,
        selectLanguageTemplateId: input.selectTemplateId,
        contactPerson: input.contactPerson,
        isShowInformationSender: input.isShowInformationSender,
        isShowImageSender: input.isShowImageSender,
        isShowPayment: input.isShowPayment,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/SendEmailTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditQuotationAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: helper.GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: helper.GetCreateAllocationTransactionItem(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/EditQuotationAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditInvoiceAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: helper.GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: helper.GetCreateAllocationTransactionItem(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/EditInvoiceAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditReceiptAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: helper.GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: helper.GetCreateAllocationTransactionItem(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/EditReceiptAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditCreditNoteAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: helper.GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: helper.GetCreateAllocationTransactionItem(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/EditCreditNoteAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEasyEditDebitNoteAllocation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      allocationTransactionList: helper.GetCreateAllocationTransaction(input.allocationTransactionList),
      allocationTransactionItemList: helper.GetCreateAllocationTransactionItem(input.allocationTransactionItemList),
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/EditDebitNoteAllocation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoLockTransactionByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/LockTransactionByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUnLockTransactionByTransactionId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/UnLockTransactionByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  RerecordStockActivityByInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/RerecordStockActivityByInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  RerecordStockActivityByReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/RerecordStockActivityByReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      invoiceId: input.transactionId,
      updateVersion: input.updateVersion,
      language: i18n.locale == "th" ? 1 : 0,
    };
    return API.peakRealTimeAPI
      .post("/api/OnlineView/UpdateInvoiceDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceiptDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      receiptId: input.transactionId,
      updateVersion: input.updateVersion,
      language: i18n.locale == "th" ? 1 : 0,
    };
    return API.peakRealTimeAPI
      .post("/api/OnlineView/UpdateReceiptDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateTaxInvoiceDetailDocument(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      taxInvoiceId: input.transactionId,
      updateVersion: input.updateVersion,
      language: i18n.locale == "th" ? 1 : 0,
    };
    return API.peakRealTimeAPI
      .post("/api/OnlineView/UpdateTaxInvoiceDetailDocument", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteReferenceDocumentPaymentList(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Finance/GetAutoCompleteReferenceDocumentPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteReferenceDocumentPaymentListByTransaction(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      referenceTransactionType: input.referenceTransactionType,
      transactionType: input.transactionType,
      transactionId: input.transactionId,
      financeType: input.financeType,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Finance/GetAutoCompleteReferenceDocumentPaymentByTransactionId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteTransactionForCreateCreditNote(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchtext: input.searchText,
    };
    return API.peakAPI
      .post("/api/Transaction/GetAutoCompleteTransactionForCreateCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteTransactionForCreateDebitNote(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      contactId: input.contactId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      searchtext: input.searchText,
    };
    return API.peakAPI
      .post("/api/Transaction/GetAutoCompleteTransactionForCreateDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalInvoice(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/ReRecordJournalInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalReceipt(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/ReRecordJournalReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalDebitNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/ReRecordJournalDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReRecordJournalCreditNote(transactionId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/ReRecordJournalCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateTransactionCreditLimit(input) {
    const _input = {
      merchantId: userInfo.MerchantId(),
      transactionType: input.transactionType,
      contactId: input.contactId,
      fromCurrencyNetTotal: input.fromCurrencyNetTotal,
    };
    return API.peakRealTimeAPI
      .post("/api/Transaction/ValidateTransactionCreditLimit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
